import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Popover, PopoverContent, PopoverTrigger } from "../ui/popover";

const PRIORITIES = ["low", "medium", "high", "urgent"];
const COLORS = {
  low: "bg-zinc-100 text-zinc-700",
  medium: "bg-blue-50 text-blue-700",
  high: "bg-amber-50 text-amber-800",
  urgent: "bg-red-50 text-red-700",
};

export default function InlinePriorityPicker({
  priority,
  onSelect,
  disabled = false,
  testId,
}) {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  return (
    <Popover open={open} onOpenChange={disabled ? undefined : setOpen}>
      <PopoverTrigger asChild>
        <button
          type="button"
          disabled={disabled}
          data-testid={testId}
          onClick={(e) => e.stopPropagation()}
          className={[
            "rounded-full px-2 py-0.5 text-[10px] uppercase tracking-wider transition-colors hover:ring-1 hover:ring-zinc-300",
            COLORS[priority] || "bg-zinc-100 text-zinc-700",
          ].join(" ")}
        >
          {t(`tasks.priority_${priority}`)}
        </button>
      </PopoverTrigger>
      <PopoverContent
        className="w-40 p-1"
        align="end"
        onClick={(e) => e.stopPropagation()}
      >
        <ul>
          {PRIORITIES.map((p) => (
            <li key={p}>
              <button
                type="button"
                onClick={() => {
                  setOpen(false);
                  onSelect(p);
                }}
                data-testid={`inline-priority-pick-${p}`}
                className={[
                  "flex w-full items-center gap-2 rounded-md px-2 py-1.5 text-left text-sm hover:bg-zinc-100 transition-colors",
                  priority === p ? "bg-zinc-50 font-medium" : "",
                ].join(" ")}
              >
                <span
                  className={[
                    "inline-block h-2 w-2 rounded-full",
                    p === "urgent"
                      ? "bg-red-500"
                      : p === "high"
                        ? "bg-amber-500"
                        : p === "medium"
                          ? "bg-blue-500"
                          : "bg-zinc-400",
                  ].join(" ")}
                />
                {t(`tasks.priority_${p}`)}
              </button>
            </li>
          ))}
        </ul>
      </PopoverContent>
    </Popover>
  );
}
